module.exports = __webpack_public_path__ + "img/score_5.e202ab16.png";